import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
import { activateAbTestByEvent } from '../../scripts/ab/registry';

// AB test 86c9nunuu - Recap quotation v1 as quotation v2/3
export default (): AlpineComponentTryba => ({
    init() {
        window.addEventListener('recap-quotation-v1', () => {
            activateAbTestByEvent('recap-quotation-v1');
            this.$store.ab.recapV2V3 = true;
            // Le titre du récap de la variante est rendu en <div> côté serveur pour éviter
            // un second <h1> dans le DOM statique (cf. H1Test). Une fois la variante affichée
            // par Alpine (x-if + x-teleport), on le promeut en <h1> pour conserver le titre SEO.
            this.promoteRecapTitle();
        });
    },
    promoteRecapTitle(attempt = 0) {
        const title = document.querySelector<HTMLElement>('.js-ab-recap-title');
        if (!title) {
            // x-if + x-teleport peuvent rendre le titre sur une frame ultérieure : on réessaie.
            if (attempt < 10) {
                requestAnimationFrame(() => this.promoteRecapTitle(attempt + 1));
            }

            return;
        }

        if ('H1' === title.tagName) {
            return;
        }

        const heading = document.createElement('h1');
        Array.from(title.attributes).forEach((attr) => heading.setAttribute(attr.name, attr.value));
        heading.innerHTML = title.innerHTML;
        title.replaceWith(heading);
    },
});
